import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axiosConfig from '../axiosConfig';
import Header from '../Header/Header';
import MainMenu from '../MainMenu/MainMenu';

const DeviceLiveDisableHistory = () => {
    const { id } = useParams();
    const [device, setDevice] = useState(null);
    const [history, setHistory] = useState([]);
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [reload, setReload] = useState(0);

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError('');
        setDevice(null);
        setHistory([]);

        // Expected API contract: { device, device_live_disable_history: [...] }.
        // Each entry contains id, live_status, created_at, user_id, user_name and comment.
        axiosConfig.get(`/device/live-disable/history/${id}`).then((response) => {
            if (!active) return;
            if (!Array.isArray(response.data?.device_live_disable_history)) {
                setError('Unable to read live status history. Please try again.');
                return;
            }
            setDevice(response.data.device);
            setHistory(response.data.device_live_disable_history);
        }).catch((err) => {
            if (active) {
                setError(err.response?.data?.message || 'Unable to load live status history. Please try again.');
            }
        }).finally(() => {
            if (active) setLoading(false);
        });

        return () => { active = false; };
    }, [id, reload]);

    const getUserName = (entry) => entry.user_name || (entry.user_id != null ? `User #${entry.user_id}` : 'Not Available');
    const search = query.trim().toLowerCase();
    const filteredHistory = history.filter((entry) =>
        [entry.live_status, entry.created_at, getUserName(entry), entry.comment]
            .some(value => String(value ?? '').toLowerCase().includes(search))
    );

    return (
        <div>
            <Header title="Device Live Disable History" />
            <MainMenu menu="device" />
            <div className="app-content content">
                <div className="content-overlay" />
                <div className="content-wrapper" style={{ backgroundColor: 'azure' }}>
                    <div className="content-body">
                        <div className="card">
                            <div className="card-body card-dashboard">
                                <div className="row">
                                    <div className="col-md-7">
                                        <h3 className="font-weight-bold">{device?.device_name || `Household ${id}`} - Device Live Disable History</h3>
                                        <p>Dashboard live enable and disable changes, including comments.</p>
                                    </div>
                                    <div className="col-md-5">
                                        <input
                                            type="search"
                                            className="search form-control round border-primary mb-1"
                                            aria-label="Search live status history"
                                            placeholder="Search by status, date, user or comment"
                                            value={query}
                                            onChange={(event) => setQuery(event.target.value)}
                                        />
                                    </div>
                                </div>
                                <Link to={`/device/detail/${id}`} className="btn btn-secondary btn-sm mb-2">Back to Household</Link>
                                {loading ? <p role="status">Loading history...</p> : error ? (
                                    <div className="alert alert-danger" role="alert">
                                        <p>{error}</p>
                                        <button type="button" className="btn btn-primary btn-sm" onClick={() => setReload(value => value + 1)}>Retry</button>
                                    </div>
                                ) : history.length === 0 ? (
                                    <p className="h3 font-weight-bold text-center">No Log Found</p>
                                ) : filteredHistory.length === 0 ? (
                                    <p className="text-center">No matching history found.</p>
                                ) : (
                                    <div className="table-responsive" style={{ maxHeight: '500px' }}>
                                        <table className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Live Status</th>
                                                    <th scope="col">Changed At</th>
                                                    <th scope="col">Changed By</th>
                                                    <th scope="col">Comment</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredHistory.map((entry) => (
                                                    <tr key={entry.id}>
                                                        <td>
                                                            <span className={entry.live_status === 'enabled' ? 'text-success' : entry.live_status === 'disabled' ? 'text-danger' : ''}>
                                                                {entry.live_status === 'enabled' ? 'Live Enable' : entry.live_status === 'disabled' ? 'Live Disable' : entry.live_status || 'Not Available'}
                                                            </span>
                                                        </td>
                                                        <td>{entry.created_at || 'Not Available'}</td>
                                                        <td>{getUserName(entry)}</td>
                                                        <td style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{entry.comment || '—'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeviceLiveDisableHistory;
